import type { AuditEntry } from "@/types/api";
import { http } from "./http";

/** The org's own trail — who invited or removed whom, and who viewed activity. */
export const auditService = {
	list: (
		opts: { limit?: number; before?: string } = {},
		signal?: AbortSignal,
	) =>
		http.get<{ entries: AuditEntry[] }>("/api/org/audit", {
			query: { limit: opts.limit, before: opts.before },
			signal,
		}),
};
